.linkButton {
	&[data-transitioning='true'] {
		opacity: 70%;
	}
}

.textLink {
	&[data-transitioning='true'] {
		opacity: 70%;
	}
	@apply --mx-fg(var(--m-fg-light));
	cursor: pointer;
	font-weight: var(--m-fw-bold);
}
